const DD_VEHICLE_STORAGE_KEY = 'dd-saved-vehicles';

function generateVehicleId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `vehicle-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function getSavedVehicles() {
  try {
    const raw = localStorage.getItem(DD_VEHICLE_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveVehicles(vehicles) {
  localStorage.setItem(DD_VEHICLE_STORAGE_KEY, JSON.stringify(vehicles));
  window.dispatchEvent(new CustomEvent('dd:vehicle-storage-change'));
}

function vehiclesMatch(vehicle, { make, year, engine, body }) {
  return (
    vehicle.make === make &&
    vehicle.year === year &&
    vehicle.engine === engine &&
    vehicle.body === body
  );
}

function addVehicle({ make, year, engine, body }) {
  const vehicles = getSavedVehicles();
  const existingVehicle = vehicles.find((vehicle) =>
    vehiclesMatch(vehicle, { make, year, engine, body })
  );

  if (existingVehicle) {
    vehicles.forEach((vehicle) => {
      vehicle.selected = vehicle.id === existingVehicle.id;
    });
    saveVehicles(vehicles);
    return existingVehicle;
  }

  vehicles.forEach((vehicle) => {
    vehicle.selected = false;
  });

  const newVehicle = {
    id: generateVehicleId(),
    make,
    year,
    engine,
    body,
    selected: true,
  };

  vehicles.push(newVehicle);
  saveVehicles(vehicles);

  return newVehicle;
}

function updateVehicle(id, { make, year, engine, body }) {
  const vehicles = getSavedVehicles();
  const index = vehicles.findIndex((vehicle) => vehicle.id === id);
  if (index < 0) return null;

  const wasSelected = vehicles[index].selected;
  vehicles[index] = {
    ...vehicles[index],
    make,
    year,
    engine,
    body,
    selected: wasSelected,
  };
  saveVehicles(vehicles);
  return vehicles[index];
}

function formatEngineDisplay(engine) {
  if (!engine) return '';
  return String(engine).replace(/-/g, '.');
}

function formatMakeDisplay(make) {
  const makeMap = {
    ford: 'Ford',
    gm: 'GM',
    ram: 'Ram',
    jeep: 'Jeep',
    benz: 'Mercedes Benz',
    nissan: 'Nissan',
  };
  return makeMap[make] || make || '';
}

function formatVehicleDisplay(vehicle) {
  if (!vehicle?.make) return '';
  const parts = [
    vehicle.year,
    formatMakeDisplay(vehicle.make),
    formatEngineDisplay(vehicle.engine),
  ].filter(Boolean);
  return parts.join(' ');
}

function getSelectedVehicle() {
  return getSavedVehicles().find((vehicle) => vehicle.selected) || null;
}

function hasSelectedVehicle() {
  return Boolean(getSelectedVehicle()?.make);
}

function selectVehicle(id) {
  const vehicles = getSavedVehicles();
  const targetVehicle = vehicles.find((vehicle) => vehicle.id === id);
  if (!targetVehicle) return null;

  vehicles.forEach((vehicle) => {
    vehicle.selected = vehicle.id === id;
  });
  saveVehicles(vehicles);

  return targetVehicle;
}

function removeVehicle(id) {
  const vehicles = getSavedVehicles();
  const removedVehicle = vehicles.find((vehicle) => vehicle.id === id);
  if (!removedVehicle) return null;

  const remainingVehicles = vehicles.filter((vehicle) => vehicle.id !== id);
  saveVehicles(remainingVehicles);

  return removedVehicle;
}

function clearSelectedVehicle() {
  const vehicles = getSavedVehicles();
  if (!vehicles.some((vehicle) => vehicle.selected)) return false;

  vehicles.forEach((vehicle) => {
    vehicle.selected = false;
  });
  saveVehicles(vehicles);

  return true;
}

window.DdVehicleStorage = {
  STORAGE_KEY: DD_VEHICLE_STORAGE_KEY,
  getSavedVehicles,
  saveVehicles,
  addVehicle,
  updateVehicle,
  getSelectedVehicle,
  hasSelectedVehicle,
  selectVehicle,
  removeVehicle,
  clearSelectedVehicle,
  formatEngineDisplay,
  formatMakeDisplay,
  formatVehicleDisplay,
};
